// import React, { useState } from "react";

// export default function BeforeAfterSlider({ lineImg, colorImg, desc }) {
//   const [position, setPosition] = useState(0.5);

//   const handleMove = (e) => {
//     const { left, width } = e.currentTarget.getBoundingClientRect();
//     const newX = (e.clientX - left) / width;
//     setPosition(Math.min(Math.max(newX, 0), 1));
//   };

//   return (
//     <div
//       style={{
//         position: "relative",
//         width: "100%",
//         height: "250px",
//         overflow: "hidden",
//         cursor: "ew-resize",
//         borderRadius: "12px",
//         boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//       }}
//       onMouseMove={handleMove}
//       onClick={handleMove}
//     >
//       {/* Line Image */}
//       <img
//         src={lineImg}
//         alt="Line Diagram"
//         style={{
//           position: "absolute",
//           inset: 0,
//           width: "100%",
//           height: "100%",
//           objectFit: "cover", // Fill container
//         }}
//       />

//       {/* Color Image with clipping */}
//       <img
//         src={colorImg}
//         alt="Color Diagram"
//         style={{
//           position: "absolute",
//           inset: 0,
//           width: "100%",
//           height: "100%",
//           objectFit: "cover",
//           clipPath: `inset(0 ${100 - position * 100}% 0 0)`, // Reveal based on position
//           transition: "clip-path 0.05s linear",
//         }}
//       />

//       {/* Slider Bar */}
//       <div
//         style={{
//           position: "absolute",
//           top: 0,
//           bottom: 0,
//           left: `${position * 100}%`,
//           width: "3px",
//           background: "#F37021",
//         }}
//       />

//       {/* Caption */}
//       {desc && (
//         <p
//           style={{
//             position: "absolute",
//             bottom: "10px",
//             left: "50%",
//             transform: "translateX(-50%)",
//             color: "#fff",
//             background: "rgba(0,0,0,0.5)",
//             padding: "5px 10px",
//             borderRadius: "6px",
//             fontSize: "0.9rem",
//           }}
//         >
//           {desc}
//         </p>
//       )}
//     </div>
//   );
// }

// import React, { useState } from "react";
// import { FaArrowsAltH } from "react-icons/fa";

// export default function BeforeAfterSlider({ lineImg, colorImg, desc }) {
//     const [position, setPosition] = useState(0.5);

//     const updatePosition = (clientX, target) => {
//         const { left, width } = target.getBoundingClientRect();
//         const newX = (clientX - left) / width;
//         setPosition(Math.min(Math.max(newX, 0), 1));
//     };

//     const handleMouseMove = (e) => {
//         updatePosition(e.clientX, e.currentTarget);
//     };

//     const handleTouchMove = (e) => {
//         if (e.touches.length > 0) {
//             updatePosition(e.touches[0].clientX, e.currentTarget);
//         }
//     };

//     return (
//         <>
//             <div
//                 style={{
//                     position: "relative",
//                     width: "100%",
//                     height: '500px',
//                     maxHeight: '600px',
//                     overflow: "hidden",
//                     cursor: "ew-resize",
//                     borderRadius: "12px",
//                     background: 'white',
//                     boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
//                     touchAction: "none", // prevent scrolling interference
//                 }}
//                 onMouseMove={handleMouseMove}
//                 onClick={handleMouseMove}
//                 onTouchStart={handleTouchMove}
//                 onTouchMove={handleTouchMove}
//             >
//                 {/* Line Image */}
//                 <img
//                     src={lineImg}
//                     alt="Line Diagram"
//                     style={{
//                         position: "absolute",
//                         inset: 0,
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "contain",
//                     }}
//                 />

//                 {/* Color Image (clipped reveal) */}
//                 <img
//                     src={colorImg}
//                     alt="Color Diagram"
//                     style={{
//                         position: "absolute",
//                         inset: 0,
//                         width: "100%",
//                         height: "100%",
//                         objectFit: "contain",
//                         clipPath: `inset(0 ${100 - position * 100}% 0 0)`,
//                         transition: "clip-path 0.05s linear",
//                         background: 'white'
//                     }}
//                 />

//                 {/* Slider Bar */}
//                 <div
//                     style={{
//                         position: "absolute",
//                         top: 0,
//                         bottom: 0,
//                         left: `${position * 100}%`,
//                         width: "3px",
//                         background: "#F37021",
//                         transform: "translateX(-50%)", // keep centered
//                     }}
//                 >
//                     {/* Draggable Handle (circle with icon) */}
//                     <div
//                         style={{
//                             position: "absolute",
//                             top: "50%",
//                             left: "50%",
//                             transform: "translate(-50%, -50%)",
//                             width: "30px",
//                             height: "30px",
//                             borderRadius: "50%",
//                             backgroundColor: "#fff",
//                             border: "2px solid #F37021",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
//                         }}
//                     >
//                         {/* Replace with any icon, for example double-arrow */}
//                         {/* <span style={{ color: "#F37021", fontSize: "16px" }}>⇆</span> */
//                             <FaArrowsAltH color="#F37021" size={16} />}
//                     </div>
//                 </div>


//                 {/* Caption */}
//                 {desc && (
//                     <p
//                         style={{
//                             position: "absolute",
//                             bottom: "10px",
//                             left: "50%",
//                             transform: "translateX(-50%)",
//                             color: "#fff",
//                             background: "rgba(0,0,0,0.5)",
//                             padding: "5px 10px",
//                             borderRadius: "6px",
//                             fontSize: "0.9rem",
//                             maxWidth: "90%",
//                             textAlign: "center",
//                         }}
//                     >
//                         {desc}
//                     </p>
//                 )}

//             </div>
//         </>
//     );
// }


import React, { useState } from "react";
import { FaArrowsAltH } from "react-icons/fa";

export default function BeforeAfterSlider({ lineImg, colorImg, desc }) {
    const [position, setPosition] = useState(0.5);

    const updatePosition = (clientX, target) => {
        const { left, width } = target.getBoundingClientRect();
        const newX = (clientX - left) / width;
        setPosition(Math.min(Math.max(newX, 0), 1));
    };

    const handleMouseMove = (e) => {
        updatePosition(e.clientX, e.currentTarget);
    };

    const handleTouchMove = (e) => {
        if (e.touches.length > 0) {
            updatePosition(e.touches[0].clientX, e.currentTarget);
        }
    };

    return (
        <div style={{ marginBottom: "20px" }}>
            {/* Slider */}
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "500px",
                    maxHeight: "600px",
                    overflow: "hidden",
                    cursor: "ew-resize",
                    borderRadius: "12px",
                    background: "white",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                    touchAction: "none", // prevent scrolling interference
                }}
                onMouseMove={handleMouseMove}
                onClick={handleMouseMove}
                onTouchStart={handleTouchMove}
                onTouchMove={handleTouchMove}
            >
                {/* Line Image */}
                <img
                    src={lineImg}
                    alt="Line Diagram"
                    style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                    }}
                />

                {/* Color Image (clipped reveal) */}
                <img
                    src={colorImg}
                    alt="Color Diagram"
                    style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        clipPath: `inset(0 ${100 - position * 100}% 0 0)`,
                        transition: "clip-path 0.05s linear",
                        background: "white",
                    }}
                />

                {/* Slider Bar */}
                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: `${position * 100}%`,
                        width: "3px",
                        background: "#F37021",
                        transform: "translateX(-50%)",
                    }}
                >
                    {/* Handle */}
                    <div
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                            border: "2px solid #F37021",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                        }}
                    >
                        <FaArrowsAltH color="#F37021" size={16} />
                    </div>
                </div>
            </div>

            {/* Description BELOW the slider */}
            {desc && (
                <p
                    style={{
                        marginTop: '10px',
                        fontSize: '1rem',
                        fontStyle: 'italic',
                        // color: 'grey'
                        color: '#F37021',
                        fontWeight: "bold",
                        textTransform: "capitalize",
                    }}
                >
                    {desc}
                </p>
            )}
        </div>
    );
}
